import * as React from 'react';

import { PageHeaderContainer } from '../PageHeader';
import { AddPostFormContainer } from '../AddPostForm';
import { PageWithSidebar as Layout } from '../../components/Layouts';
import { SidebarWhatToAskAboutTip, SidebarFindRealtorTip } from '../../components/SidebarTips';

/**
 * Контейнер страницы добавления/редактирования вопроса
 */
export const AddQuestionPageContainer = () => {
  return (
    <Layout header={<PageHeaderContainer />} body={<AddPostFormContainer />}>
      <SidebarWhatToAskAboutTip />
      <SidebarFindRealtorTip />
    </Layout>
  );
};
